export default __webpack_public_path__ + "static/media/login-img.afa19b23.webp";